import React, { useEffect, useRef } from "react";
import { useMediaQuery } from "@mui/material";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Swiper, SwiperSlide } from "swiper/react";
import {
  Navigation,
  Pagination,
  Grid,
  EffectCards,
  Autoplay,
} from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/grid";
import "swiper/css/effect-cards";
import "./Roadmap.css";
import { useLanguage } from "../../context/LanguageContext";
import { translations, getT } from "../../translations";

gsap.registerPlugin(ScrollTrigger);

function Roadmap() {
  const { lang } = useLanguage();
  const t = getT(lang);
  const phases = translations[lang]?.roadmap?.phases ?? translations.zh.roadmap.phases;
  const containerRef = useRef(null);
  const titleRef = useRef(null);
  const isMobile = useMediaQuery("(max-width: 768px)");

  useEffect(() => {
    const container = containerRef.current;
    const title = titleRef.current;
    if (!container || !title) return;

    gsap.set(title, { opacity: 0, scale: 0.5, y: 30 });
    gsap.to(title, {
      opacity: 1,
      scale: 1,
      y: 0,
      duration: 0.9,
      ease: "back.out(1.6)",
      scrollTrigger: {
        trigger: container,
        start: "top 80%",
        toggleActions: "play none none none",
      },
    });

    return () => ScrollTrigger.getAll().forEach((t) => t.kill());
  }, []);

  return (
    <div id="roadmap" className="roadmap-container" ref={containerRef}>
      <h2 className="roadmap-title" ref={titleRef}>
        {t("roadmap.title")}
      </h2>

      {!isMobile ? (
        /* Desktop: 2x2 grid with Swiper */
       
        <div className="roadmap-swiper-wrap roadmap-swiper-wrap--grid">
          
          <div className="roadmap-nav roadmap-prev" aria-label="Previous" />
          <div className="roadmap-nav roadmap-next" aria-label="Next" />
          <Swiper
            className="roadmap-swiper"
            modules={[Navigation, Pagination, Grid]}
            spaceBetween={24}
            slidesPerView={2}
            grid={{ rows: 2, fill: "row" }}
            pagination={{
              clickable: true,
              el: ".roadmap-pagination--grid",
              bulletClass: "roadmap-bullet",
              bulletActiveClass: "roadmap-bullet--active",
            }}
            navigation={{
              nextEl: ".roadmap-next",
              prevEl: ".roadmap-prev",
            }}
            onSlideChange={() => {}}
          >
            {phases.map((phase, index) => (
              <SwiperSlide key={index}>
                <div className="roadmap-card">
                  <div className="roadmap-phase">{phase.title}</div>
                  <ul>
                    {phase.items.map((item, i) => (
                      <li key={i}>{item}</li>
                    ))}
                  </ul>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          <div className="roadmap-pagination roadmap-pagination--grid" />
        </div>
      ) : (
        /* Mobile: Cards effect slider */
        <div className="roadmap-swiper-wrap roadmap-swiper-wrap--cards">
          
          <Swiper
            className="roadmap-swiper roadmap-swiper--cards"
            modules={[Pagination, EffectCards, Autoplay]}
            effect="cards"
            grabCursor
            pagination={{
              clickable: true,
              el: ".roadmap-pagination--cards",
              bulletClass: "roadmap-bullet",
              bulletActiveClass: "roadmap-bullet--active",
            }}
            cardsEffect={{
              slideShadows: false,
              perSlideOffset: 8,
              perSlideRotate: 2,
            }}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
            }}
            onSlideChange={() => {}}
          >
            {phases.map((phase, index) => (
              <SwiperSlide key={index}>
                
                <div className="roadmap-card">
                  
                  <div className="roadmap-phase">{phase.title}</div>
                  
                  <ul>
                    
                    {phase.items.map((item, i) => (
                      <li key={i}>{item}</li>
                    ))}
                  </ul>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          <div className="roadmap-pagination roadmap-pagination--cards" />
        </div>
      )}
    </div>
  );
}

export default Roadmap;
